
export const displayDestinationNotReachYetSelector = ({displayDestinationNotReachYet}) => displayDestinationNotReachYet